import { GlossaryTypes } from "@medapro-types/AttributeManager/GlossaryTypes";
import api from "./api";
import endpoints from "./endpoints";
import { useSanitize } from "@common/composable/useSanitize";
const { sanitizeFilename } = useSanitize();

export default {
  getGlossaries: async function () {
    const response = await api.get(endpoints.deepLTranslation.glossary.getGlossaries, { params: {} });
    return response.data;
  },
  getGlossaryEntries: async function (glossaryId: GlossaryTypes.GlossaryItem) {
    const response = await api.post(endpoints.deepLTranslation.glossary.getGlossaryEntries, glossaryId);
    return response.data;
  },
  deleteGlossary: async function (glossaryItem: GlossaryTypes.GlossaryItem) {
    const response = await api.post(endpoints.deepLTranslation.glossary.deleteGlossary, glossaryItem);
    return response.data;
  },
  updateGlossary: async function (glossaryWithEntries: GlossaryTypes.GlossaryItemToUpdate) {
    const response = await api.post(endpoints.deepLTranslation.glossary.updateGlossary, glossaryWithEntries);
    return response.data;
  },
  getGlossaryLanguagePairs: async function () {
    const response = await api.get(endpoints.deepLTranslation.glossary.getGlossaryLanguagePairs, { params: {} });
    return response.data;
  },
  exportGlossaryEntriesToFile: async function (glossaryItem: GlossaryTypes.GlossaryItem) {
    const response = await api.post(endpoints.deepLTranslation.glossary.exportGlossaryEntriesToFile, glossaryItem);
    return response.data;
  },
  importGlossaryEntriesFromFile: async function (glossaryItem: GlossaryTypes.GlossaryItem, file: any) {
    const formData = new FormData();
    formData.append("glossary", JSON.stringify(glossaryItem));
    formData.append("file", file, sanitizeFilename(file.name));
    const response = await api.post(endpoints.deepLTranslation.glossary.importGlossaryEntriesFromFile, formData);
    return response.data;
  }
};
